<script setup>
import AlertTable from '@frontJs/components/tables/AlertTable.vue';
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { route } = useRoute();

const loading = ref(true);

const data = ref({
    all: 0,
    netlinking: 0,
    appointment: 0,
    seo: 0,
    sea: 0,
    sma: 0,
    tasks: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(route('front.postAlertCount'), {
            ongoing: true,
        }),
        axios.post(route('front.postAlertCount'), {
            group: 'seo',
            type: 'dead_netlinking_link',
            ongoing: true,
        }),
        axios.post(route('front.postAlertCount'), {
            group: 'apikom',
            type: 'appointment_to_make',
            ongoing: true,
        }),
        axios.post(route('front.postAlertCount'), {
            group: 'seo',
            type: 'position_tracking_request',
            ongoing: true,
        }),
        axios.post(route('front.postAlertCount'), {
            group: 'sea',
            type: 'no_google_ads_costs',
            ongoing: true,
        }),
        axios.post(route('front.postAlertCount'), {
            group: 'sma',
            type: 'no_facebook_ads_costs',
            ongoing: true,
        }),
        axios.post(route('front.postAlertCount'), {
            group: 'invoices',
            type: 'problematic_invoices',
            ongoing: true,
        }),
        axios.post(route('front.postAlertCount'), {
            group: 'tasks',
            type: 'customer_task_to_validate',
            ongoing: true,
        }),
        axios.post(route('front.postAlertCount'), {
            processed: true,
        }),
    ])
        .then((response) => {
            data.value.all = response[0].data.count;
            data.value.netlinking = response[1].data.count;
            data.value.appointment = response[2].data.count;
            data.value.seo = response[3].data.count;
            data.value.sea = response[4].data.count;
            data.value.sma = response[5].data.count;
            data.value.invoices = response[6].data.count;
            data.value.tasks = response[7].data.count;
            data.value.processed = response[8].data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title>Alertes - Datakepler</title>
    </Head>

    <PageTitle> Alertes </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                total: data.all,
                content: h(AlertTable, {
                    ongoing: true,
                }),
            },
            appointment: {
                title: 'RDV - Apikom',
                total: data.appointment,
                content: h(AlertTable, {
                    group: 'apikom',
                    type: 'appointment_to_make',
                    ongoing: true,
                    callback: updateData,
                }),
            },
            netlinkingSeo: {
                title: 'Netlinking - SEO',
                total: data.netlinking,
                content: h(AlertTable, {
                    type: 'dead_netlinking_link',
                    ongoing: true,
                    callback: updateData,
                }),
            },
            positionTrackingSeo: {
                title: 'Suivi de positions - SEO',
                total: data.seo,
                content: h(AlertTable, {
                    group: 'seo',
                    type: 'position_tracking_request',
                    ongoing: true,
                    callback: updateData,
                }),
            },
            sea: {
                title: 'SEA',
                total: data.sea,
                content: h(AlertTable, {
                    group: 'sea',
                    type: 'no_google_ads_costs',
                    ongoing: true,
                    callback: updateData,
                }),
            },
            sma: {
                title: 'SMA',
                total: data.sma,
                content: h(AlertTable, {
                    group: 'sma',
                    type: 'no_facebook_ads_costs',
                    ongoing: true,
                    callback: updateData,
                }),
            },
            invoices: {
                title: 'Factures',
                total: data.invoices,
                content: h(AlertTable, {
                    group: 'invoices',
                    type: 'problematic_invoices',
                    ongoing: true,
                    callback: updateData,
                }),
            },
            processed: {
                title: 'Traitées',
                total: data.processed,
                content: h(AlertTable, {
                    processed: true,
                    callback: updateData,
                }),
            },
        }"
        :loading="loading"
    />
</template>
